import { Directive, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

/**
 * Shim interne de la librairie morte `ng-click-outside`.
 * Émet l'événement (clickOutside) quand un clic document survient HORS de l'élément hôte.
 */
@Directive({
  selector: '[clickOutside]',
  standalone: false
})
export class ClickOutsideDirective implements OnInit, OnDestroy {
  @Input() delayClickOutsideInit = false;
  @Output() clickOutside = new EventEmitter<Event>();

  private _initTimeoutId: any = null;

  constructor(private _el: ElementRef) {
    this._onClickBody = this._onClickBody.bind(this);
  }

  ngOnInit(): void {
    if (this.delayClickOutsideInit) {
      // N'attache le listener qu'après un tick pour éviter que le clic
      // d'ouverture ne déclenche immédiatement l'émission.
      this._initTimeoutId = setTimeout(() => this._init());
    } else {
      this._init();
    }
  }

  ngOnDestroy(): void {
    if (this._initTimeoutId !== null) {
      clearTimeout(this._initTimeoutId);
      this._initTimeoutId = null;
    }
    document.removeEventListener('click', this._onClickBody);
  }

  private _init(): void {
    this._initTimeoutId = null;
    document.addEventListener('click', this._onClickBody);
  }

  private _onClickBody(event: Event): void {
    if (!this._el.nativeElement.contains(event.target)) {
      this.clickOutside.emit(event);
    }
  }
}
